import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      paddingLeft: theme.spacing(1.5)
    },
    icon: {
      fontSize: 15
    },
    badge: {
      '& .MuiBadge-badge': {
        fontSize: 8,
        padding: 1
      }
    },
    collapsed: {
      display: 'flex',
      alignItems: 'center'
    },
    expanded: {
      width: 240 - theme.spacing(3),
      display: 'flex',
      alignItems: 'center',
      '& p': {
        paddingLeft: theme.spacing(1.5)
      }
    }
  });
